<template>
    <Layout>
      <b-modal
        id="modalModificarAvance"
        scrollable
        title="Avance Partida"
        title-class="font-18"
        size="lg"
        hide-footer
      >
      <b-overlay :show="isLoadingModal">
        <form class="needs-validation" @submit.prevent="agregarModificarPartidaSubmit">
          <div class="form-row">
            <div class="form-group col-md-12" style="z-index: 10">
              <label>Partida</label>
              <p><strong>{{partida_modificar.partida}}</strong></p>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-md-3">
              <label>Cantidad</label>
              <input
                  class="form-control" v-model="partida_modificar.cantidad"
                  :disabled="disable_modificar_partida_cantidad"
                  @input="calcularSubtotalPartidaModificada()"
              />
              <!--:class="{ 'is-invalid': submittedModificarPartida && $v.partida_modificar.cantidad.$error }"-->
              <!--<div v-if="submittedModificarPartida && $v.partida_modificar.cantidad.$error" class="invalid-feedback">
                <span v-if="!$v.partida_modificar.cantidad.required">Este valor es requerido.</span>
                <span v-if="!$v.partida_modificar.cantidad.decimal">Solos se adminte numeros.</span>
              </div>-->
            </div>

            <div class="form-group col-md-3" >
              <label>C. U.</label>
              <input
                  class="form-control" v-model="partida_modificar.costo_unitario"
                  :disabled="disable_modificar_partida_costo_unitario"
                  @input="calcularSubtotalPartidaModificada()"
              />
              <!--:class="{ 'is-invalid': submittedModificarPartida && $v.partida_modificar.costo_unitario.$error }"-->
              <!--<div v-if="submittedModificarPartida && $v.partida_modificar.costo_unitario.$error" class="invalid-feedback">
                <span v-if="!$v.partida_modificar.costo_unitario.required">Este valor es requerido.</span>
                <span v-if="!$v.partida_modificar.costo_unitario.decimal">Solos se adminte numeros.</span>
              </div>-->
            </div>

            <div class="form-group col-md-3" >
              <label>Subtotal</label>
              <input
                  class="form-control" v-model="partida_modificar.subtotal"

                  :disabled="disable_modificar_partida_subtotal"
              />
              <!--:class="{ 'is-invalid': submittedModificarPartida && $v.partida_modificar.subtotal.$error }"-->

              <!--<div v-if="submittedModificarPartida && $v.partida_modificar.subtotal.$error" class="invalid-feedback">
                <span v-if="!$v.partida_modificar.subtotal.required">Este valor es requerido.</span>
                <span v-if="!$v.partida_modificar.subtotal.decimal">Solos se adminte numeros.</span>
              </div>-->
            </div>
            <div class="form-group col-md-3">
              <label>Fecha</label>
              <VueCtkDateTimePicker
                  v-model="partida_modificar.fecha"
                  :locale="'es'"
                  :input-size="'sm'"
                  :format="'YYYY-MM-DD'"
                  :formatted="'YYYY-MM-DD'"
                  :range="false"
                  :auto-close="true"
                  :only-date="true"
                  :no-header="true"
                  style="position: fixed;width: 180px"

              />
              <!--:class="{ 'is-invalid': submittedModificarPartida && $v.partida_modificar.fecha.$error }"-->
              <!--<div v-if="submittedModificarPartida && $v.partida_modificar.fecha.$error" class="invalid-feedback">
                <span v-if="!$v.partida_modificar.fecha.required">Este valor es requerido.</span>
              </div>-->
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-6">
              <label>Estado</label>
              <select class="form-control" v-model="partida_modificar.estado" >
                <option value="0">Sin revisión</option>
                <option value="1">Enviado para revisión</option>
                <option value="2">Validado</option>
                <option value="3">Observador</option>
                <option value="10">Con error</option>
              </select>
            </div>

          </div>
          <div class="form-row text-right">
            <button type="button"
                v-show="$can('avance-forzar-edicion')" v-on:click="guardarPartidaAvance(partida_modificar.id)"
                    class="btn btn-primary mt-4 mr-2"><i class="fa fa-save"></i> Forzar Guardado
            </button>
            <button type="button"
                    v-show="$can('avance-forzar-edicion')" v-on:click="forzarEliminarAvance(partida_modificar.id)"
                    class="btn btn-danger mt-4"><i class="fa fa-trash"></i> Forzar eliminación
            </button>
          </div>
          <hr>
          <h4>Revisiones:</h4>
          <div class="form-row" v-if="partida_modificar.revision">
            <ul>
              <li>Cantidad: {{partida_modificar.revision.cantidad}}</li>
              <li>CU: {{partida_modificar.revision.costo_unitario}}</li>
              <li>Subtotal: {{partida_modificar.revision.subtotal}}</li>
            </ul>
            <ul>
              <li>Cantidad corregida:  {{partida_modificar.revision.cantidad_corregida}}</li>
              <li>Subtotal corregida: {{partida_modificar.revision.subtotal_corregido}}</li>
              <li>observacion: {{partida_modificar.revision.observacion}}</li>
            </ul>
          </div>
        </form>
      </b-overlay>

      </b-modal>
      <b-modal
          id="modalVerAvance"
          scrollable
          title="Avance Partida"
          title-class="font-18"
          size="xl"
          hide-footer
      >
        <PartidaAvanceInfo :data="partida_avance" v-on:registro-completado="registroHojaMetradoCompletado" />
      </b-modal>
      <b-modal
          id="modalCuadernoObra"
          scrollable
          title="Cuaderno de obra"
          title-class="font-18"
          size="lg"
          hide-footer
      >
        <cuadernoObra :data="data_cuaderno_obra" />
      </b-modal>
      <b-modal
          id="modalRevisionPartidas"
          scrollable
          title="Revisión partidas"
          title-class="font-18"
          size="xl"
      >
        <b-overlay :show="isLoading" rounded="sm">
          <envioRevisionPartidas :data="partidas_revision" />
        </b-overlay>
        <template #modal-footer="{ ok, cancel, hide }">
          <h4>Monto valorizado: S/ {{partidas_revision.total}}</h4>
          <!-- Emulate built in modal footer ok and cancel button actions -->
          <button class="btn btn-primary" v-on:click="guardarPartidasAvance">Enviar</button>
          <button class="btn btn-secondary" v-on:click="cerrarFormularioRevision" >Salir</button>
        </template>
      </b-modal>

      <div class="card">
          <form class="needs-validation" @submit.prevent="formSubmit">
            <b-overlay :show="isLoading" rounded="sm">
                <div class="card-body">
                  <div class="form-row">
                    <div class="col-md-6">
                      <h4>Registrar avance</h4>
                    </div>
                    <div class="col-md-6 text-right">
                      <button type="button" v-show="$can('avance-ver')"
                              class="btn btn-outline-primary mr-2" v-on:click="descargarExcel">
                        <i class="fa fa-file-excel"></i> Exportar
                      </button>
                      <button type="button" class="btn btn-outline-primary" v-on:click="enviarParaRevision">
                        <i class="fa fa-arrow-right"></i> Enviar avance para revisión
                      </button>
                    </div>
                  </div>
                  <br>

                  <div class="form-row">
                      <div class="form-group col-md-9">
                          <label>Expediente</label>
                          <v-select
                                  :options="expedientes"
                                  label="obra_expediente"
                                  :reduce="desc=>desc.expediente_id"
                                  v-model="expediente_id"
                                  @input="cargarPartidasyAvance()"
                                  :class="{ 'is-invalid': submitted && $v.expediente_id.$error }"
                          />
                          <div v-if="submitted && $v.expediente_id.$error" class="invalid-feedback">
                              <span v-if="!$v.expediente_id.required">Este valor es requerido.</span>
                          </div>
                      </div>
                      <div class="form-group col-md-3">
                          <label>Fecha</label>
                          <VueCtkDateTimePicker
                                  v-model="fecha"
                                  :locale="'es'"
                                  :input-size="'sm'"
                                  :format="'YYYY-MM-DD'"
                                  :formatted="'YYYY-MM-DD'"
                                  :range="false"
                                  :auto-close="true"
                                  :only-date="true"
                                  :no-header="true"
                                  @input="cargarAvance()"
                                  :class="{ 'is-invalid': submitted && $v.fecha.$error }"
                          />
                          <div v-if="submitted && $v.fecha.$error" class="invalid-feedback">
                              <span v-if="!$v.fecha.required">Este valor es requerido.</span>
                          </div>
                      </div>

                  </div>
                  <div class="form-row">
                      <div class="form-group col-md-12">
                          <label>Partida</label>
                          <v-select
                                  :options="partidas"
                                  label="descripcion"
                                  v-model="partida"
                                  :class="{ 'is-invalid': submitted && $v.partida.$error }"
                          />
                          <div v-if="submitted && $v.partida.$error" class="invalid-feedback">
                              <span v-if="!$v.partida.required">Este valor es requerido.</span>
                          </div>
                      </div>

                  </div>
                  <div class="form-row">
                      <div class="form-group col-md-2">
                          <label>Cantidad</label>
                          <!--<input
                                  class="form-control"
                                  v-model="cantidad"
                                  :class="{ 'is-invalid': submitted && $v.cantidad.$error }"
                                  :disabled="disable_cantidad"
                                  @input="calcularSubtotal()"
                          >-->
                          <div class="input-group">
                            <input
                                type="text"
                                v-model="cantidad"
                                class="form-control"
                                :class="{ 'is-invalid': submitted && $v.cantidad.$error }"
                                :disabled="disable_cantidad"
                                @input="calcularSubtotal()"
                            >
                            <div class="input-group-append">
                              <span class="input-group-text" id="basic-addon2">{{partida.unidad_medida}}</span>
                            </div>
                          </div>

                          <div v-if="submitted && $v.cantidad.$error" class="invalid-feedback">
                              <span v-if="!$v.cantidad.required">Este valor es requerido.</span>
                              <span v-if="!$v.cantidad.numeric">Solo se acepta numeros.</span>
                          </div>
                      </div>
                      <div class="form-group col-md-2">
                          <label>C.U.</label>
                          <input class="form-control" v-model="costo_unitario" :disabled="disable_costo_unitario">
                      </div>
                      <div class="form-group col-md-2">
                          <label>Parcial</label>
                          <input class="form-control" v-model="subtotal" :disabled="disable_subtotal">
                      </div>
                      <!--<div class="form-group col-md-3">
                        <b-input-group append="Metrado" class="mt-4">
                          <b-button class="btn btn-primary">Agregar</b-button>-->
                          <!--<button type="submit" v-show="$can('avance-agregar')"
                                  class="btn btn-primary"><i class="fa fa-plus"></i> Agregar</button>
                          <b-input-group-prepend is-text>
                            <input type="checkbox" >
                          </b-input-group-prepend>
                        </b-input-group>
                      </div>-->
                      <div class="form-group col-md-6" >
                        <div class="form-row">

                          <div class="col-md-6">
                            <button type="submit" v-show="$can('avance-agregar')"
                                    class="btn btn-primary mt-4"><i class="fa fa-plus"></i> Agregar</button>
                            <button type="button" v-show="$can('avance-modificar')"
                                    class="btn btn-primary mt-4 ml-2" v-on:click="guardarLista">
                              <i class="fa fa-save"></i> Guardar lista
                            </button>
                          </div>
                          <div class="col-md-6">
                            <b-form-checkbox
                                v-model="detallar_metrado"
                                class="mt-4"
                            >
                              Detallar metrado
                            </b-form-checkbox>
                          </div>
                        </div>
                        <!--<div class="custom-control custom-checkbox">
                          <input id="customControlInline" type="checkbox" class="custom-control-input" />
                          <label class="custom-control-label" for="customControlInline">Metrado</label>
                        </div>-->
                      </div>
                  </div>
                  <div class="row">
                      <div class="col-md-12">
                          <ag-grid-vue
                                  style="width: 100%; height: 400px"
                                  class="ag-theme-balham"
                                  :columnDefs="columnDefs"
                                  :gridOptions="gridOptions"
                                  @grid-ready="onGridReady"
                                  :context="context"
                                  :rowData="rowData"
                                  :enterMovesDownAfterEdit="true"
                                  :singleClickEdit="true"
                          >
                          </ag-grid-vue>
                      </div>

                      <div class="col-md-12 text-right mt-4">
                        <h4><strong>Total:</strong> S/ {{total}}</h4>
                      </div>
                      <div class="col-md-12 text-right">
                        <h4><strong>Total mayor metrado:</strong> S/ {{total_mayor_metrado}}</h4>
                      </div>
                  </div>
                </div>
            </b-overlay>
            </form>
        </div>
    </Layout>
</template>

<script>
    import Layout from "../../layouts/main";
    import appConfig from "@/app.config";

    import subirArchivos from "@/components/subir-archivos";
    import envioRevisionPartidas from "@/components/envio-revision-partidas.vue";
    import cuadernoObra from "@/components/cuaderno-obra.vue";


    /* eslint-disable vue/no-unused-components */
    import deleteButton from  "@/components/delete-button";
    import modificarAvanceButton from "@/components/modificar-avance-button.vue";

    import {/*email, maxLength, minLength,*/decimal, required} from "vuelidate/lib/validators";

    import PartidaAvanceInfo from "@/components/partida-avance-info.vue";

    //import constantes from "../../../config/Constantes";
    /**
     * Dashboard Component
     */
    export default {
        page: {
            title: "Avance",
            meta: [{ name: "description", content: appConfig.description }]
        },
        components: {
          PartidaAvanceInfo,
          Layout,
          //PageHeader,
          subirArchivos,
          deleteButton,
          envioRevisionPartidas,
          cuadernoObra,
          modificarAvanceButton

        },
        data() {
            return {
              title: "Avance",
              items: [
                  {
                      text: "Avance",
                      href: "/"
                  },
                  {
                      text: "Lista",
                      active: true
                  }
              ],
              isLoading: false,
              gridApi: null,
              columnApi: null,
              gridOptions: {
                  defaultColDef: {
                      sortable: true,resizable: true
                  },
              },
              partida_avance:{},

              columnDefs:[],
              rowData:[],
              expedientes:[],
              expediente_id:null,
              total:0,
              total_mayor_metrado:0,
              fecha:null,
              partida: {
                unidad_medida:""
              },
              partidas:[],
              cantidad:"",
              costo_unitario:0,
              subtotal:0,
              submitted: false,



              context:null,
              disable_subtotal:true,
              disable_cantidad:false,
              disable_costo_unitario:true,

              partidas_revision:{
                partidas:[]
              },
              data_cuaderno_obra:{},
              ///modificar partidas
              partida_modificar:{},
              isLoadingModal:false,
              submittedModificarPartida:false,
              disable_modificar_partida_subtotal:false,
              disable_modificar_partida_cantidad:false,
              disable_modificar_partida_costo_unitario:false,
              //////new/////////
              hotInstance: null,
              ////////////////
              detallar_metrado:true


            };
        },

        methods: {
            ///handsone table
            agregarModificarPartidaSubmit(){
              console.log("out out");
            },
            //////////////////////////
            forzarEliminarAvance(id){
              this.$swal.fire({
                title: '¿Esta seguro?',
                text: "No se puede revertir esta accion!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#d33',
                cancelButtonColor: '#3085d6',
                confirmButtonText: 'Si, borralo!'
              }).then((result) => {
                if (result.value) {
                  this.isLoadingModal=true;
                  this.axios.post(process.env.VUE_APP_BACKEND +'/api/avance/forzar-borrado/'+id)
                      .then(()=>{
                        this.$bvModal.hide("modalModificarAvance");
                      })
                      .catch((r)=>{
                        this.$swal('error',r.response.data.mensaje,'warning');
                      })
                      .finally(()=>
                          {
                            this.isLoadingModal=false;
                            this.cargarAvance();
                          }
                      );
                }
              })
            },
            guardarPartidaAvance(id){
              this.isLoadingModal=true;
              this.partida_modificar.avance_id=id;
              this.axios.post(process.env.VUE_APP_BACKEND + "/api/avance/forzar-guardado",
                    this.partida_modificar
                  )
                  .then(() => {
                    this.$bvModal.hide("modalModificarAvance");

                    this.cargarAvance()
                  })
                  .catch((r)=>{
                    this.$swal('error',r.response.data.mensaje,'warning');
                  })
                  .finally(()=>{
                    this.isLoadingModal=false;
                  });
            },
            calcularSubtotalPartidaModificada(){
              if(this.partida_modificar.tipo_costo=="Costo directo"){
                  this.partida_modificar.subtotal=
                      Math.round(this.partida_modificar.costo_unitario*this.partida_modificar.cantidad*100)/100;
              }
            },
            modificarAvance(row){
              this.isLoading=true;
              this.axios.get(process.env.VUE_APP_BACKEND + "/api/avance/"+row.id)
                  .then((response) => {
                    this.$bvModal.show("modalModificarAvance");
                    this.partida_modificar=response.data;
                  }, () => {

                    this.$swal("error","Error cargando el avance",'error')
                    // Manage errors
                  })
                  .finally(()=>{
                    this.isLoading=false;
                  });
            },
            mostrarMetrado(){
              this.$bvModal.show("modalHojaMetrado");
            },
            descargarExcel(){
              this.isLoading=true;
              this.axios.get(process.env.VUE_APP_BACKEND + "/api/avance/reporte-excel/"+this.expediente_id+'/'+this.fecha,
                  {
                    responseType: 'arraybuffer',
                    //'params':data
                  })
                  .then(response => {
                    this.$downloadFile(response, 'avance.xlsx','application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
                  }, response => {
                    console.warn('error from download_contract');
                    console.log(response);
                    this.$swal("error","Error generando el reporte",'error')
                    // Manage errors
                  })
                  .finally(()=>{
                    this.isLoading=false;
                  });
            },
            cuadernoObraMostrarFormulario(){
              if(this.expediente_id!=null){
                this.data_cuaderno_obra={
                  expediente_id:this.expediente_id,
                  fecha:this.fecha
                };
                this.$bvModal.show("modalCuadernoObra");
              }
              else
              {
                this.$swal('Cuidado',"Seleccione un expediente.",'warning');
              }

            },
            cargarPartidasyAvance(){
              this.cargarPartidas();
              this.cargarAvance();
            },
            cerrarFormularioRevision(){
              this.$bvModal.hide("modalRevisionPartidas");
            },
            guardarPartidasAvance(){
              this.$swal.fire({
                title: '¿Esta seguro de enviar el avance de partidas para revisión?',
                text: "",
                icon: 'warning',
                showCancelButton: true,
                //confirmButtonColor: '#d33',
                //cancelButtonColor: '#3085d6',
                confirmButtonText: 'Si'
              }).then((result) => {
                if (result.value) {
                  this.isLoading=true;
                  this.axios.post(process.env.VUE_APP_BACKEND +'/api/revision',{
                    expediente_id:this.expediente_id,
                    partidas:this.partidas_revision.partidas
                  })
                  .then(()=>{
                    this.$swal('Ok',"Se guardo correctamente",'success');
                    this.$bvModal.hide("modalRevisionPartidas");
                  })
                  .catch((r)=>{
                    this.$swal('error',r.response.data.mensaje,'warning');
                  })
                  .finally(
                      ()=>
                      {
                        this.isLoading=false;
                        this.cargarAvance();
                      }
                  );
                }
              })

            },
            enviarParaRevision(){
              this.isLoading=true;
              this.axios.get(process.env.VUE_APP_BACKEND +"/api/avance/partidas-para-revision",
                  {
                    params: {
                      expediente_id:this.expediente_id,
                      fecha:this.fecha
                    }
                  })
                  .then((response) => {
                    this.partidas_revision=response.data;
                    this.$bvModal.show("modalRevisionPartidas");
                  })
                  .catch((r)=>{
                    this.$swal('Cuidado',r.response.data.mensaje,'warning');
                  })
                  .finally(()=>this.isLoading=false)
            },
            guardarLista(){
                this.isLoading=true;
                this.axios.post(process.env.VUE_APP_BACKEND +"/api/avance/guardar-lista",{
                    lista:this.getAllRows()
                })
                .then(() => {
                    this.cargarAvance();
                })
                .catch((r)=>{

                  this.$swal('Cuidado',r.response.data.mensaje,'warning');
                })
                .finally(()=>this.isLoading=false)
            },
            calcularSubtotal(){
              if(this.partida.tipo_costo=="Costo directo"){
                  this.subtotal=Math.round(this.costo_unitario*this.cantidad*100)/100;
              }
            },

            cargarPartidas(){
                this.isLoading=true;
                this.axios.get(process.env.VUE_APP_BACKEND +"/api/expediente/partidas/"+this.expediente_id)
                    .then((response) => {
                     this.partidas= response.data.partidas;
                    ///this.total=response.data.total;
                    //this.rowData=response.data;
                })
                .catch(()=>{
                  this.$swal('Cuidado',"Error cargando las partidas",'warning');
                })
                .finally(()=>this.isLoading=false)
            },
            cargarAvance(){
                this.isLoading=true;
                this.axios.get(process.env.VUE_APP_BACKEND + "/api/avance/reporte/"+this.expediente_id+'/'+this.fecha
                )
                .then((response)=>{
                  this.rowData=response.data.partidas;
                  this.total=response.data.total;
                  this.total_mayor_metrado=response.data.total_mayor_metrado;
                    //this.cast();
                })
                .catch(()=>{
                  this.$swal('Cuidado',"Error cargando el avance",'warning');
                })
                .finally(()=>this.isLoading=false)
            },
            getAllRows() {
                let rowData = [];
                this.gridApi.forEachNode(node => rowData.push(node.data));
                return rowData;
            },
            cast(){
                this.gridApi.setRowData(this.rowData);
            },
            formSubmit() {
                this.submitted = true;
                console.log(this.$v);
                // stop here if form is invalid
                this.$v.$touch();
                if(this.$v.$error==false){
                    this.agregar();
                }
                else
                {
                  this.$swal("Cuidado","Formulario no valido","warning");
                }
            },
            //verificar si es metrado o no
            //////////////OLD
            agregar(){
              if(this.detallar_metrado && this.partida.tipo_costo==="Costo directo"){
                  this.partida_avance={};
                  this.partida_avance.id=0;
                  this.partida_avance.expediente_id=this.expediente_id;
                  this.partida_avance.partida_id=this.partida.id;
                  this.partida_avance.fecha=this.fecha;
                  this.partida_avance.costo_unitario=this.partida.costo_unitario;
                  this.partida_avance.tipo_costo=this.partida.tipo_costo;
                  this.partida_avance.codigo_partida=this.partida.codigo_partida;
                  this.partida_avance.partida=this.partida.descripcion;
                  this.partida_avance.unidad_medida=this.partida.unidad_medida;
                  this.partida_avance.hoja_metrado=[];
                  this.$bvModal.show("modalVerAvance");
                  return;
              }
              this.agregarAvance();

            },
            agregarAvance(){
              if(this.subtotal==0){
                this.$swal('Cuidado',"El subtotal no puede ser 0",'warning');
                return;
              }
              this.isLoading=true;
              this.axios.post(process.env.VUE_APP_BACKEND + "/api/avance",
                  {
                    expediente_id:this.expediente_id,
                    partida_id:this.partida.id,
                    cantidad:this.cantidad,
                    costo_unitario:this.costo_unitario,
                    tipo_costo:this.partida.tipo_costo,
                    fecha:this.fecha,
                    subtotal:this.subtotal
                  }
              )
                  .then(()=>{
                    this.cargarAvance();
                  })
                  .catch((r)=>{

                    this.$swal('Cuidado',r.response.data.mensaje,'warning');
                  })
                  .finally(()=>this.isLoading=false)
            },
            registroHojaMetradoCompletado(){
              this.$bvModal.hide("modalVerAvance");
              this.cargarAvance();
            },
            borrar(row){
                this.$swal.fire({
                    title: '¿Esta seguro?',
                    text: "No se puede revertir esta accion!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#d33',
                    cancelButtonColor: '#3085d6',
                    confirmButtonText: 'Si, borralo!'
                }).then((result) => {
                    if (result.value) {
                        this.isLoading=true;
                        this.axios.delete(process.env.VUE_APP_BACKEND +'/api/avance/'+row.id)
                        .catch((r)=>{
                            this.$swal('error',r.response.data.mensaje,'warning');
                        })
                        .finally(
                            ()=>
                            {
                                this.isLoading=false;
                                this.cargarAvance();
                            }
                        );
                    }
                })
            },
            ////////////////////
            abrirCarga(){
                this.$bvModal.show("modalUpload");
            },
            cargarOpciones(){

            },

            cellValueChanged(params){
                if(params.column.colId=="cantidad"){
                    this.calcular();
                }
            },
            calcular(){
                this.rowData=this.getAllRows();
                this.total=0;
                for(var i=0;i<this.rowData.length;i++){
                  if( this.rowData[i].tipo_costo=="Costo directo"){
                    this.rowData[i].subtotal=Math.round(this.rowData[i].cantidad*this.rowData[i].costo_unitario * 100) / 100;
                  }
                  this.total=this.total+parseFloat(this.rowData[i].subtotal);
                }
                this.total=this.total.toFixed(2);
                this.cast();
            },
            rowDoubleClicked(row){

              if(row.data.tipo_costo==="Costo directo"){
                this.isLoading=true;
                this.axios.get(process.env.VUE_APP_BACKEND + "/api/avance/"+row.data.id)
                    .then((response)=>{
                      this.partida_avance=response.data;
                      this.$bvModal.show("modalVerAvance");
                    })
                    .finally(()=>this.isLoading=false)
              }
              else
              {
                this.$swal('Cuidado',"Valido solo para costo directo",'warning');
              }

            },
            onGridReady(params) {
                this.gridApi = params.api;
                this.gridColumnApi = params.columnApi;
                this.gridApi.addEventListener('cellValueChanged',this.cellValueChanged);
                this.gridApi.addEventListener('rowDoubleClicked',this.rowDoubleClicked);
            },
            isCellEditable(params) {
                return params.data.tipo_costo === 'Costo directo';
            },
            uploadComplete(files){
                this.isLoading=true;
                this.axios.post(process.env.VUE_APP_BACKEND + "/api/estudiantes/procesar-lista",
                    {
                        file:files,
                    })
                    .then((response)=>{
                        console.log(response);
                        this.rowData=response.data;
                        this.$bvModal.hide("modalUpload");
                    })
                    .finally(()=>this.isLoading=false)
            },


        },
        watch:{
            partida:function (val){
                if(val.tipo_costo=="Costo directo"){
                    this.cantidad=0;
                    this.costo_unitario=val.costo_unitario;
                    this.subtotal=0;
                    this.disable_subtotal=true;
                    this.disable_cantidad=false;
                    this.disable_costo_unitario=true;
                }
                else
                {
                    this.costo_unitario=0;
                    this.cantidad=0;
                    this.subtotal=0;
                    this.disable_subtotal=false;
                    this.disable_cantidad=true;
                    this.disable_costo_unitario=true;
                }
            }
        },
        computed:{

        },
        beforeMount() {
            this.columnDefs= [
                { headerName: "ID", field: "id" ,width:30 ,hide: "true" },
                { headerName: "Tipo", field: "tipo",width:30 ,hide: "true" },
                { headerName: "Expediente_id", field: "expediente_id",width:30 ,hide: "true" },
                { headerName: "Codigo", field: "codigo_partida",width:100 , filter: false},
                { headerName: "Partida", field: "partida", width:350, filter: true,  floatingFilter: true, },
                { headerName: "UM", field: "unidad_medida", width:50},
                {
                    headerName: "Cant",
                    field: "cantidad",
                    width:90,
                    editable:false
                    /*editable: (params) => {
                     return (
                         params.data.tipo == 'P' &&
                         params.data.tipo_costo == 'Costo directo' &&
                         params.data.estado==0 &&
                         this.$can('avance-modificar')
                     );
                    },*/
                    /*cellStyle: (params) => {
                        if (
                            (params.data.tipo_costo === 'Costo directo') &&
                            (params.data.estado==0) &&
                            this.$can('avance-modificar')
                        ) {
                            return { backgroundColor: '#FFFFCD',textAlign: "right" };
                        }
                        else
                        {
                            return {textAlign: "right"};
                        }
                    },*/
                },
                { headerName: "C.U.", field: "costo_unitario", width:90,  cellStyle: {textAlign: "right"}},
                {
                    headerName: "Subtotal",
                    field: "subtotal",
                    width:100,
                    editable: (params)=> {
                      return (
                              params.data.tipo_costo == 'Costo indirecto' &&
                              params.data.estado==0 &&
                              this.$can('avance-modificar')
                      )
                    } ,
                    cellStyle: (params) => {
                        if (
                            params.data.tipo_costo == 'Costo indirecto'  &&
                            params.data.estado==0 &&
                            this.$can('avance-modificar')
                        ) {
                            return { backgroundColor: '#FFFFCD',textAlign: "right" };
                        }
                        else
                        {
                            return {textAlign: "right"};
                        }
                    },
                },
                {
                  headerName: "MM Cant.",
                  field: "cantidad_mayor_metrado",
                  width:90,
                  cellStyle: {textAlign: "right"}
                },
                { headerName: "Fecha", field: "fecha",width:100 },
                {
                  headerName: "Estado",field:"estado_str",width: 140
                },
                //numero_fotos
                {
                  headerName: "Archivos",field:"numero_archivos",width: 80
                },
                {
                  width: 80,
                  headerName: "Borrar",
                  cellRenderer:'deleteButton'
                },
                {
                  width: 80,
                  headerName: "Modificar",
                  cellRenderer:'modificarAvanceButton'
                }

            ];
            this.rowData= [

            ];
            this.context = { componentParent: this };

        },
        validations: {

            cantidad:{required,decimal},
            fecha:{required},
            expediente_id:{required},
            partida:{required},

            /*partida_modificar:{
              costo_unitario:{required,decimal},
              cantidad:{required,decimal},
              subtotal:{required,decimal},
              fecha:{required}
            }*/

        },


        mounted() {
          var date= new Date();
          this.fecha=new Date(date.getTime() - (date.getTimezoneOffset() * 60000)).toISOString().substring(0, 10)
          //this.cargarExpedientes();
          this.$cargarExpedientes((res)=>{
            this.expedientes=res.data;
            if(this.expedientes.length>0){
              this.expediente_id=this.expedientes[0].expediente_id;
              this.cargarPartidasyAvance();
              //this.actualizar();
            }
          })


        },
    };
</script>

<style>
</style>